import React, { useState, useEffect, useContext } from "react";
import Layout from "../../components/Layout/Layout";
import { db } from "../../firebase/firebase-config";
import { useAuthState } from 'react-firebase-hooks/auth';
import { collection, query, where, getDocs, doc, deleteDoc } from "firebase/firestore";
import { Table, Input, Select } from 'antd';
import { auth } from '../../firebase/firebase-config';
import BeatLoader from "react-spinners/BeatLoader";
import PatientProfileModal from "../../components/ui/PatientProfileModal/PatientProfileModal";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { BiUserPin } from 'react-icons/bi';
import PatientInfoModal from "./PatientInfoModal/PatientInfoModal";
import { BsFillTrashFill } from 'react-icons/bs';
import { ConfirmModal } from "../../components";
import { deleteUser } from "firebase/auth";
import { toast } from "react-toastify";
import moment from 'moment';
import { MdContentCopy } from "react-icons/md";

const { Search } = Input;



const override = {
  marginTop: "20px",
};


function Index() {
  const [allPatientsData, setAllPatientsData] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [searchText, setSearchText] = useState<string>('');
  const [filteredData, setFilteredData] = useState<any[]>(allPatientsData);

  const [activeUserData, setActiveUserData] = useState(null);
  const [showPatientDetailsModal, setShowPatientDetailsModal] = useState(false);

  const [showConfirmodal, setShowConfirmModal] = useState(false);
  const [currentActiveId, setCurrentActiveId] = useState(null);


  const [user] = useAuthState(auth);


  const [loading, setLoading] = useState(false);

  const toggleAddModal = async () => {
    // fetchUsers().then(doc => console.log(doc.data()))
    setShowCreateModal(!showCreateModal);
  };

  const formatTimeStamp = (milliseconds:string,data:any) =>{

    const date = isNaN(parseInt(milliseconds))? data?.toDate(): new Date(parseInt(milliseconds))
    const month = String(date?.getMonth() + 1).padStart(2,"0")
    const day = String(date?.getDate()).padStart(2,"0")
    const year = date?.getFullYear();


      return `${month}-${day}-${year}`

  }

  const handleContentAdded = () => {
    toggleAddModal();
    //FETCH DATA
    fetchData();
  };


  const copyToClipBoard = (data: any) => {
    navigator.clipboard.writeText(`${data}`);

    toast.success("Copied To Clipboard", {
      pauseOnHover: false,
      closeOnClick: true,
    });
  };
  
  const rows: any = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (text: any, record: any, index: number) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "displayName",
      key: "displayName",
      sorter: (a: any, b: any) => a.displayName.localeCompare(b.displayName),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a: any, b: any) => a.email.localeCompare(b.email),
      render: (email: any) => (email ? email : '--'),
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      sorter: (a: any, b: any) => a.gender.localeCompare(b.gender),
      render: (gender: any) => (gender ? gender : '--'),
    },
    {
      title: "Verified",
      dataIndex: "is_verified",
      key: "is_verified",
      sorter: (a: any, b: any) => (a.is_verified ? 1 : -1) - (b.is_verified ? 1 : -1),
      render: (is_verified: any) => (is_verified ? 'Yes' : 'No'),
    },
    {
      title: "Phone",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      sorter: (a: any, b: any) => a.phoneNumber.localeCompare(b.phoneNumber),
      render: (phoneNumber: any) => (phoneNumber ? phoneNumber : '--'),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt: any)=> (formatTimeStamp(`${createdAt}`,createdAt)),
      // sorter: (a: any, b: any) => a.createdAt.localeCompare(b.createdAt),
      // sorter: (a: any, b: any) => {
      //   const dateA = new Date(a.createdAt);
      //   const dateB = new Date(b.createdAt);
      //   return dateA.getTime() - dateB.getTime();
      // },
  
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text: any, record: any) => (
        <td className="flex-center" style={{display: 'flex'}}>
          <div className="action">
              <Tippy content="Patient Details" animation="fade">
                <a
                  className="see"
                  onClick={() => {
                    // Add your logic here when Activate button is clicked
                    
                    setActiveUserData(record);
                    setShowPatientDetailsModal(true)
                  }}
                >
                <BiUserPin
                  style={{
                    color: "white",
                  }}
                   size={18} />
                </a>
              </Tippy>
          </div>
          <div className="action">
              <Tippy content="Delete Patient" animation="fade">
                <a
                  className="see"
                  onClick={() => {
                    // Add your logic here when Activate button is clicked
                    // console.log('RECORD:', record);
                    setShowConfirmModal(true)
                    setCurrentActiveId(record?.uid);
                    // setActiveUserData(record);
                    // setShowPatientDetailsModal(true)
                  }}
                  style={{ backgroundColor: "#FF0000",}}
                >
                <BsFillTrashFill
                  style={{
                    borderRadius: 5,
                    color: "white",
                  }}
                  size={18}
                />
                </a>
              </Tippy>
          </div>

          <div className="action">
              <Tippy content="Copy ID" animation="fade">
                <a
                  className="see"
                  onClick={() => {
                    copyToClipBoard(record?.id);
                  }}
                  style={{ backgroundColor: "#4F5052",}}
                >
                <MdContentCopy
                  style={{
                    borderRadius: 5,
                    color: "white",
                  }}
                  size={18}
                />
                </a>
              </Tippy>
          </div>
        </td>
      ),
  
    },
  ];

  const fetchData = async () => {
    setLoading(true);


    const querySnapshot = await getDocs(collection(db, "Patients"));

    const patientsData: any = [];

    querySnapshot.forEach((doc) => {
      patientsData.push({
        id: doc.id,
        ...doc.data()
      })
      // console.log('PATIENT DATA: ');
      // console.log(doc.id, " => ", doc.data());
    });

    // const sortedData = newData.sort((a: any, b: any) => moment(b?.createdAt.seconds * 1000).diff(moment(a?.createdAt.seconds * 1000)));
    const sortedData = patientsData.sort((a: any, b: any) => {
      const momentA = moment(a.createdAt.seconds * 1000 || a.createdAt);
      const momentB = moment(b.createdAt.seconds * 1000 || b.createdAt);
      return momentB.diff(momentA);
    });

    setAllPatientsData(sortedData)

    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [sortedInfo, setSortedInfo] = useState<any>({});

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    setSortedInfo(sorter);
  };

  allPatientsData.forEach((item: any, index: any) => {
    item.index = index + 1;
  });

  useEffect(() => {
    setFilteredData(filterData(allPatientsData, searchText));
  }, [allPatientsData, searchText]);

  const filterData = (data: any[], query: string) => {
    if (!query) return data;

    return data.filter((item) =>
      Object.values(item).some((value: any) =>
        value?.toString().toLowerCase().includes(query.toLowerCase())
      )
    );
  };


  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  const deletePatient = async(patientId: any) => {

    // LOGIC TO DELETE PATIENT
    // deleteUser()
    const docRef = doc(collection(db,"Patients"),patientId)
    setShowConfirmModal(false);
    if(patientId != null) {
        await deleteDoc(docRef).then(() => {
          fetchData();
          setShowConfirmModal(false);
          toast.success("Patient Deleted", {
            pauseOnHover: false,
            closeOnClick: true,
          });
        })
    }
  }


  return (
    <>
    <Layout title="Patients" pageTitle="patients">
      <div className="section">
        <div className="parent-con">
          <div className="data-table">
            <div className="top">
              <div className="span">
                <h3>All Patients</h3>
              </div>

              <button 
               onClick={toggleAddModal}
              className="btn btn-primary btn-add student-button">
                New Patient
              </button>
            </div>
            <div className="table-con">
                <div style={{ textAlign: "center" }}>
                  <BeatLoader
                    color="#3080ED"
                    loading={loading}
                    cssOverride={override}
                  />
                </div>
                <Search
                  placeholder="Search for data..."
                  onSearch={handleSearch}
                  onChange={(e) => handleSearch(e.target.value)}
                  value={searchText}
                  style={{ width: 200, marginBottom: 16 }}
                />

                <Table

                  dataSource={filteredData.map((item, index) => ({ ...item, index: index + 1 }))}

                  columns={rows}
                  onChange={handleChange}
                  rowKey="num"
                  showSorterTooltip={false}

                  pagination={{ pageSize: 10 }}
                />

              </div>
  
          </div>
        </div>
      </div>
    </Layout>

    {showConfirmodal && (
          <ConfirmModal 
              title="Are you sure you want to delete patient ?"
              onAccept={() => deletePatient(currentActiveId)}
              onCancel={() => setShowConfirmModal(false)}
          />
      )}

     {showCreateModal && (
      <PatientProfileModal
        onContentAdded={handleContentAdded}
        onClose={toggleAddModal}
      />
    )}

    {showPatientDetailsModal && (
        <PatientInfoModal user={activeUserData} onCancel={() => setShowPatientDetailsModal(false)} />
      )}
    </>
  );
}

export default Index;
